import React from 'react'
import { connect } from 'react-redux'
import { fetchZedlinesIfNeeded } from '~/news/actions'
import PlayMedia from '~/core/components/PlayMedia'
import { DateTime } from 'luxon'

const Zedlines = (props) => {
	let last = null

	const debug = (ev) => {
    if (last) {
      last.style.display = 'none'
    }

    ev.currentTarget.nextSibling.style.display = 'block'
    last = ev.currentTarget.nextSibling
  }

	return (
	<div>
		{ props.zedlines.items.map((zedline, index) => (
			<div className="section" key={index}>
				{ zedline.type[0].target_id !== 'zedlines_story' &&
					<h3 style={{textTransform: 'uppercase', textAlign: 'center'}}>{zedline.title[0].value}</h3>
				}

				{ zedline.field_image ?
				<div className="image">
					<div className="bulletin-image">
						<img src={  zedline.field_image[0].url } />
					</div>

					{ zedline.zedlines_bulletin && zedline.zedlines_bulletin[0] ?
						<PlayMedia className="play-button" media={zedline.zedlines_bulletin[0].url} title={zedline.title[0].value} />
					: null }
				</div>
				: null }
				{ zedline.type[0].target_id !== 'zedlines_story' ?
				<div className="bulletin">
					<div className="date">{ DateTime.fromISO(zedline.created[0].value).toLocaleString(DateTime.DATE_MED)}
					</div>
					<div dangerouslySetInnerHTML={ { __html: zedline.body[0].value } } />
				</div>
				:
				<div className="story">
					<h3 onClick={debug}>{zedline.title[0].value}</h3>
					<div style={{ display: 'none' }}>
						<div className="date">{ DateTime.fromISO(zedline.created[0].value).toLocaleString(DateTime.TIME_SIMPLE)}
						</div>
						<div dangerouslySetInnerHTML={ { __html: zedline.body[0].value } } />
					</div>
				</div>
				}
			</div>
			))
		}
	</div>

)}

export default connect(state => ({ zedlines: state.zedlines })) (Zedlines)
